<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-flowRecord__flowrecord}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.userId" placeholder="用户ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-input v-model="dataForm.code" placeholder="订单编号" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" placeholder="类型" clearable filterable >
            <el-option
                v-for="item in statusArray"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('flowRecord:flowrecord:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('flowRecord:flowrecord:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="主键ID" width="80" header-align="center" align="center"></el-table-column>
        <el-table-column prop="userId" label="用户ID" width="100" header-align="center" align="center"></el-table-column>
        <el-table-column prop="memberNichen" label="用户昵称" width="130" header-align="center" align="center"></el-table-column>
        <el-table-column prop="code" label="订单编号" width="180" header-align="center" align="center"></el-table-column>
        <el-table-column prop="amount" label="金币数量" width="130" header-align="center" align="center"></el-table-column>
        <el-table-column prop="frontBalance" label="前金币数量" width="130" header-align="center" align="center"></el-table-column>
        <el-table-column prop="afterBalance" label="后金币数量" width="130" header-align="center" align="center"></el-table-column>
        <el-table-column prop="status" label="类型" :show-overflow-tooltip="true" width="130" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0" type="warning">购买影视全集</el-tag>
            <el-tag v-if="scope.row.status === 1" size="success" type="success">购买影视单集</el-tag>
            <el-tag v-if="scope.row.status === 3" size="success" type="info">购买小说</el-tag>
            <el-tag v-if="scope.row.status === 4" size="success" type="danger">邀请分享送一天VIP</el-tag>
            <el-tag v-if="scope.row.status === 6" size="success" type="info">每日签到赠送金币</el-tag>
            <el-tag v-if="scope.row.status === 7" size="success" type="danger">每日签到赠送试用VIP</el-tag>
            <el-tag v-if="scope.row.status === 8" size="success" type="danger">每日观看视频20分钟赠送金币</el-tag>
            <el-tag v-if="scope.row.status === 9" size="success" type="danger">首次充值赠送金币</el-tag>
            <el-tag v-if="scope.row.status === 10" size="success" type="danger">每日登录</el-tag>
            <el-tag v-if="scope.row.status === 11" size="success" type="danger">VIP充值赠送金币</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="illuStrate" label="说明" :show-overflow-tooltip="true" width="300" header-align="center" align="center"></el-table-column>
        <el-table-column prop="resId" label="资源ID" :show-overflow-tooltip="true" width="200" header-align="center" align="center"></el-table-column>
        <el-table-column prop="amountSource" label="来源" :show-overflow-tooltip="true" width="200" header-align="center" align="center"></el-table-column>
        <el-table-column prop="time" label="时间" width="180" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('flowRecord:flowrecord:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('flowRecord:flowrecord:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import dateTimeRangeMixin from '@/mixins/datetime-range'
import AddOrUpdate from './flowrecord-add-or-update'
export default {
  mixins: [mixinViewModule, dateTimeRangeMixin],
  data () {
    return {
      statusArray:[
        {
          value: '0',
          label: '购买影视全集'
        },{
          value: '1',
          label: '购买影视单集'
        },{
          value: '3',
          label: '购买小说'
        },{
          value: '4',
          label: '邀请分享送一天VIP'
        },{
          value: '6',
          label: '每日签到赠送金币'
        },{
          value: '7',
          label: '每日签到赠送试用VIP'
        },{
          value: '8',
          label: '每日观看视频20分钟赠送金币'
        },{
          value: '9',
          label: '首次充值赠送金币'
        },{
          value: '10',
          label: '每日登录'
        },{
          value: '11',
          label: 'VIP充值赠送金币'
        }
      ],
      mixinViewModuleOptions: {
        getDataListURL: '/flowRecord/flowrecord/page',
        getDataListIsPage: true,
        exportURL: '/flowRecord/flowrecord/export',
        deleteURL: '/flowRecord/flowrecord',
        deleteIsBatch: true
      },
      dateRange: null,
      dataForm: {
        userId: '',
        code: '',
        status: '',
      }
    }
  },
  components: {
    AddOrUpdate
  },
  watch: {
    'dateRange'(val) {
      if (!val || val.length === 0) {
        this.dataForm.startDate = null
        this.dataForm.endDate = null
      } else {
        // datetimerange 已经包含完整的日期时间,直接赋值
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      }
      console.log('======>'+JSON.stringify(this.dataForm));
    }
  },
}
</script>
